const initialState = {
	isLoading: 0,
	hasError: 0,
	banners: null
};

export default (state = initialState, action) => {
	switch (action.type) {
		case "BANNERS_ARE_LOADING":
			return {
				...state,
				isLoading: 1
			};
		case "BANNERS_HAS_ERROR":
			return {
				...state,
				isLoading: 0,
				hasError: 1,
				error: action.error
			};
		case "BANNERS_SUCCESS":
			return {
				...state,
				banners: action.data.data.banners,
				isLoading: 0
			};

		default:
			return state;
	}
};



// WEBPACK FOOTER //
// ./src/store/reducers/banners.js